'use strict';
window.ERMoney = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', {
  style:'currency',currency:window.ERTheme.currency,maximumFractionDigits:2
}).format(Number(cents)/100);
// Catalog amounts stay in USD for order audit. UI amounts come from Shopify Markets.
(() => {
  const packages=window.ERLensPackagesFor,materials=window.ERLensMaterialsFor;
  const native=window.ERTheme.lenses || [];
  const resolve=(type,id)=>window.ER_SHOPIFY_LENS_CATALOG?.variants.find(v=>v.vision===type && v.packageId===id);
  const price=(type,id)=>{
    const mapping=resolve(type,id),variant=native.find(v=>v.id===mapping?.variantId);
    if (!variant || !variant.available || !Number.isSafeInteger(variant.price)) return null;
    return variant.price;
  };
  // Plano and single vision have the same approved material prices.
  window.ERLensMaterialsFor=type=>materials(type).map(material=>({...material,
    baseFee:price(type==='none'?'none':material.type,window.ERLensPackageId(material.type,material.id,0))
  })).filter(material=>material.baseFee!==null);
  window.ERLensPackagesFor=product=>packages(product).map(pack=>{
    const fee=price(pack.type,pack.id),base=price(pack.type,window.ERLensPackageId(pack.type,pack.materialId,0));
    return {...pack,fee,baseFee:base};
  }).filter(pack=>pack.fee!==null && pack.baseFee!==null);
  const pc0=price('single',window.ERLensPackageId('single','pc',0));
  const pc1=price('single',window.ERLensPackageId('single','pc',1));
  if (pc0!==null && pc1!==null) window.ER_LENS_PRICING.featureFee=pc1-pc0;
  window.ERFeaturePrice=(pack,bit)=>{
    if(!pack)return window.ER_LENS_PRICING.featureFee;
    const other=price(pack.type,window.ERLensPackageId(pack.type,pack.materialId,pack.featureMask^bit));
    return pack.featureMask&bit ? pack.fee-other : other-pack.fee;
  };
  window.ERLensPriceRows=pack=>{
    if (!pack) return [];
    let previous=pack.baseFee,mask=0;
    const rows=[{label:'Material base',fee:previous}];
    for (const feature of window.ER_LENS_PRICING.features.filter(item=>pack.features.includes(item.id))) {
      mask |= feature.bit;
      const current=price(pack.type,window.ERLensPackageId(pack.type,pack.materialId,mask));
      rows.push({label:feature.label,fee:current-previous});previous=current;
    }
    return rows;
  };
})();
